export default __webpack_public_path__ + "static/media/abs.5f9a9b20.png";